import { Form, Input, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { getQueryParams } from "../../../utilities/getQueryParams";
import { OrderDetailsAPI } from "../../../redux/actions/adminActions/orderDetailsAction";
import { useDispatch } from "react-redux";
import Alertify from "../../../services/alertify";

const { Title } = Typography;

const OrderDetailsPage = () => {
  const [freightType, setFreightType] = useState("");
  const params = getQueryParams();
  const orderIds = params.orderId;
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    const data = {
      uuid: orderIds,
    };
    if (orderIds) {
      dispatch(OrderDetailsAPI(data))
        .then((response) => {
          const formData = response.payload.data.data;
          // console.log("The Form Data is+++++++++", formData);
          setFreightType(formData?.freight_type);
          form.setFieldsValue(formData);
        })
        .catch((error) => {
          Alertify.error("Failed to fetch Order Details: " + error.message);
        });
    }
  }, [orderIds, dispatch, form]);

  return (
    <>
      <Title level={2} className="text-left">
        Order Details: {orderIds}
      </Title>
      <Form form={form} layout="vertical">
        {/* Dealer Info */}
        <div className="border p-4 rounded-lg my-4">
          <Title level={3} className="text-left py-4">
            Dealer Info
          </Title>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="Dealer Name" name="dealerName">
                <Input placeholder="Dealer Name" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2 text-left">
              <Form.Item
                label="Dealer Code"
                name="dealer_code"
                rules={[
                  {
                    required: true,
                    message: "Please select Dealer Code",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="Email Address" name="email">
                <Input type="email" placeholder="Email" disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="Mobile Number" name="mblNumber">
                <Input type="number" placeholder="Mobile Number" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="GST Number" name="gst">
                <Input placeholder="GST01210212" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2"></div>
          </div>
        </div>

        {/* Addresses */}
        <div className="border p-4 rounded-lg my-4">
          <Title level={3} className="text-left py-4">
            Shipping Address
          </Title>
          <div className="sm:flex">
            {/* <div className="w-full mx-2"> */}
            {/* <Form.Item
                label="Shipping Addresses"
                name="shipAddresses"
                rules={[
                  {
                    required: true,
                    message: "Please select Shipping Address",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item> */}
            {/* <Form.Item
                className="hidden"
                label="Address Code"
                name="dealerShipping"
              >
                <Input placeholder="Address Line 1" disabled />
              </Form.Item> */}
            {/* </div> */}
            <div className="w-full mx-2">
              <Form.Item label="Address Line 1" name="shipAddressLine1">
                <Input placeholder="Address Line 1" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="Address Line 2" name="shipAddressLine2">
                <Input placeholder="Address Line 2" disabled />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="State" name="shipState">
                <Input placeholder="State" disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="City" name="shipCity">
                <Input placeholder="City" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="w-full sm:w-1/2 mx-2">
            <Form.Item label="PIN Code" name="shipPin">
              <Input placeholder="123456" disabled />
            </Form.Item>
          </div>
        </div>
        <div className="border p-4 rounded-lg my-4">
          <Title level={3} className="text-left py-4">
            Billing Address
          </Title>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="Address Line 1" name="billAddressLine1">
                <Input placeholder="Address Line 1" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="Address Line 2" name="billAddressLine2">
                <Input placeholder="Address Line 2" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="State" name="billState">
                <Input placeholder="State" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="City" name="billCity">
                <Input placeholder="City" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="PIN Code" name="billPin">
                <Input placeholder="123456" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2"></div>
          </div>
        </div>

        {/* Order Details */}
        <div className="border p-4 rounded-lg my-4">
          <Title level={3} className="text-left py-4">
            Order Details
          </Title>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="Location Code"
                name="location_code"
                rules={[
                  {
                    required: true,
                    message: "Please select Location code",
                  },
                ]}
              >
                <Select
                  disabled
                  className="text-left"
                  placeholder="Select Location Code"
                  options={[{ value: "FG-RDP", label: "Finished Good Store" }]}
                />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Branch Code"
                name="branch_code"
                rules={[
                  {
                    required: true,
                    message: "Please select Branch Code",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  disabled
                  placeholder="Select Branch Code"
                  options={[
                    {
                      label: "AAIPL Rudrapur",
                      value: "RDP",
                    },
                  ]}
                />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="Project Segment"
                name="project_segment"
                rules={[
                  {
                    required: true,
                    message: "Please select Project Segment",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select Project Segment"
                  options={[
                    {
                      label: "Power Plant",
                      value: "Power Plant",
                    },
                    {
                      label: "Hospital",
                      value: "Hospital",
                    },
                    {
                      label: "Mall/Multiplex",
                      value: "Mall/ Multiplex",
                    },
                    {
                      label: "IT/ITES",
                      value: "IT/ITES",
                    },
                    {
                      label: "Office Building",
                      value: "Office Building",
                    },
                    {
                      label: "OEM",
                      value: "OEM",
                    },
                    {
                      label: "Institution",
                      value: "Institution",
                    },
                    {
                      label: "Defence",
                      value: "Defence",
                    },
                    {
                      label: "Hotel",
                      value: "Hotel",
                    },
                    {
                      label: "Refinery",
                      value: "Refinery",
                    },
                    {
                      label: "Dairy",
                      value: "Dairy",
                    },
                    {
                      label: "Metro",
                      value: "Metro",
                    },
                    {
                      label: "Airport",
                      value: "Airport",
                    },
                    {
                      label: "Railways",
                      value: "Railways",
                    },
                    {
                      label: "Pharma",
                      value: "Pharma",
                    },
                    {
                      label: "Process",
                      value: "Process",
                    },
                    {
                      label: "Factory",
                      value: "Factory",
                    },
                    {
                      label: "Cold Storage",
                      value: "Cold Storage",
                    },
                    {
                      label: "Warehouse",
                      value: "Warehouse",
                    },
                    {
                      label: "Eco sheet - Non Specified Projects",
                      value: "Eco sheet - Non Specified Projects",
                    },
                    {
                      label: "Eco Tube/tapes - Retail Market",
                      value: "Eco Tube/tapes - Retail Market",
                    },
                  ]}
                  disabled
                />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Requested Delivery Date"
                name="requestedDate"
                rules={[
                  {
                    required: true,
                    message: "Please enter Requested Delivery Date",
                  },
                ]}
              >
                <Input type="date" disabled />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="Transaction Type"
                name="transaction_type"
                rules={[
                  {
                    required: true,
                    message: "Please select Transaction Type",
                  },
                ]}
              >
                <Select
                  disabled
                  className="text-left"
                  placeholder="Select "
                  options={[
                    {
                      label: "Pay Later",
                      value: "cod",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Project Type"
                name="project_type"
                rules={[
                  {
                    required: true,
                    message: "Please select Project Type",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="External Document Number"
                name="doc_number"
                rules={[
                  {
                    required: true,
                    message: "Please enter External Document Number",
                  },
                ]}
              >
                <Input placeholder="External Document Number" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Order Type"
                name="orderType"
                rules={[
                  {
                    required: true,
                    message: "Please select Order Type",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="BD Person" name="bd_person_name">
                <Input disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="Consultant Name" name="consultant_name">
                <Input placeholder="Consultant Name" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="Opportunity Number" name="opportunity_number">
                <Input placeholder="Opportunity Number" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2"></div>
          </div>
        </div>

        {/* Products & Payment Details */}
        <div className="border p-4 rounded-lg">
          <Title level={3} className="text-left py-4">
            Products
          </Title>

          <Form.List name="products">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name: fieldName }) => (
                  <div
                    key={key}
                    className="add relative border p-4 rounded-lg mb-5 bg-slate-50"
                  >
                    {/* {fields.length > 1 && (
                      <Button
                        type="text"
                        icon={<CloseOutlined />}
                        className="absolute right-1 top-1 h-[20px] w-[20px]"
                        onClick={() => remove(fieldName)}
                      />
                    )} */}
                    <div className="sm:flex">
                      <div className="w-full sm:me-4">
                        <Form.Item
                          label="Title"
                          name={[fieldName, "title"]}
                          rules={[
                            {
                              required: true,
                              message: "Please select Product!",
                            },
                          ]}
                        >
                          <Input disabled />
                        </Form.Item>
                      </div>
                      <div className="w-full sm:flex ">
                        <Form.Item
                          className="sm:me-4"
                          label="Pack Of"
                          name={[
                            fieldName,
                            "packaging_quantity_wholesaler_box",
                          ]}
                        >
                          <Input placeholder="pack of" type="number" disabled />
                        </Form.Item>
                        <Form.Item
                          className="sm:me-4"
                          label="Unit Price"
                          name={[fieldName, "unit_price"]}
                        >
                          <Input
                            placeholder="Unit Price"
                            type="number"
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          className="hidden"
                          label="MSP"
                          name={[fieldName, "msp"]}
                        >
                          <Input placeholder="MSP" type="number" disabled />
                        </Form.Item>
                        <Form.Item
                          label="Box Price"
                          name={[fieldName, "boxPrice"]}
                        >
                          <Input
                            placeholder="Box Price"
                            type="number"
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="w-full sm:flex ">
                      <Form.Item
                        className="sm:me-4"
                        label="Qty(No. of Boxes)"
                        name={[fieldName, "quantity"]}
                      >
                        <Input
                          placeholder="Number of Boxes"
                          type="number"
                          disabled
                        />
                      </Form.Item>
                      <Form.Item
                        className="sm:me-4"
                        label="Total Price"
                        name={[fieldName, "total_price"]}
                      >
                        <Input
                          placeholder="Total Price"
                          type="number"
                          disabled
                        />
                      </Form.Item>
                      <Form.Item
                        label="Discount"
                        name={[fieldName, "discount"]}
                        className="sm:me-4 sm:w-[16.67%]"
                      >
                        <Input placeholder="Discount" type="number" disabled />
                      </Form.Item>
                      <Form.Item
                        className="sm:me-4"
                        label="Price After Discount"
                        name={[fieldName, "pad"]}
                      >
                        <Input
                          placeholder="Price After Discount"
                          type="number"
                          disabled
                        />
                      </Form.Item>
                      <Form.Item
                        className="sm:me-4"
                        label="GST"
                        name={[fieldName, "gst"]}
                      >
                        <Input placeholder="GST" type="number" disabled />
                      </Form.Item>
                      <Form.Item
                        className="hidden"
                        label="GST Number"
                        name={[fieldName, "gstNumber"]}
                      >
                        <Input
                          placeholder="GST Number"
                          type="number"
                          disabled
                        />
                      </Form.Item>
                      <Form.Item
                        label="Price After GST"
                        name={[fieldName, "final_price"]}
                      >
                        <Input
                          placeholder="Price After GST"
                          type="number"
                          disabled
                        />
                      </Form.Item>
                    </div>
                  </div>
                ))}
              </>
            )}
          </Form.List>
        </div>
        <div className="border p-4 rounded-lg mt-4">
          <Title level={3} className="text-left py-4">
            Payment Details
          </Title>
          <div className="sm:flex">
            <div className="w-full sm:me-4">
              <Form.Item
                label="Freight Type"
                name="freight_type"
                rules={[
                  {
                    required: true,
                    message: "Please select Freight Type",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:me-4">
              {freightType === "Freight As per Customer PO" && (
                <Form.Item
                  className="sm:me-4"
                  label="Freight Percent"
                  name="freight_percent"
                  rules={[
                    {
                      required: true,
                      message: "Please type Freight Percent",
                    },
                  ]}
                >
                  <Input placeholder="Freight Percent" disabled />
                </Form.Item>
              )}
              {freightType === "Freight Added to Invoice" && (
                <Form.Item
                  className="sm:me-4"
                  label="Freight Subsidy"
                  name="subsidy"
                >
                  <Input disabled />
                </Form.Item>
              )}
            </div>
            <div className="w-full sm:me-4"></div>
          </div>
          <div className="w-full sm:flex">
            <div className="w-full">
              <Form.Item
                className="sm:me-4"
                label="Total Weight"
                name="totalWeight"
              >
                <Input placeholder="Total Weight" type="number" disabled />
              </Form.Item>
            </div>
            <div className="w-full">
              <Form.Item className="sm:me-4" label="Sub Total" name="subTotal">
                <Input placeholder="Sub Total" type="number" disabled />
              </Form.Item>
            </div>
            <div className="w-full">
              <Form.Item label="Total GST" name="totalGST">
                <Input placeholder="Total GST" type="number" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="w-full sm:flex">
            <div className="w-full">
              <Form.Item
                className="sm:me-4"
                label="Grand Total"
                name="grandTotal"
              >
                <Input placeholder="Grand Total" type="number" disabled />
              </Form.Item>
            </div>
            <div className="w-full">
              <Form.Item
                className="sm:me-4"
                label="Payment Method"
                name="payment_method"
              >
                <Input placeholder="Payment Method" disabled />
              </Form.Item>
            </div>
            <div className="w-full">
              <Form.Item
                className="sm:me-4"
                label="Balanced Credit Limit"
                name="balance_credit"
              >
                <Input placeholder="Balanced Credit Limit" disabled />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default OrderDetailsPage;
